import React from "react";
import PropTypes from "prop-types";
import Utility from "app/horoscope/utility/utility";
import { useTranslation } from "react-i18next";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function PlanetAspectsTable({ planetData }) {
    const { t } = useTranslation();
    return (
        <div>
            <div style={sectionTitleStyle}>
                {t("BhavaPlanetAspectsTitle")}
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}></th>
                        <th style={thStyleCompact}>{t("PLANET")}</th>
                        <th style={thStyleCompact}>{t("Nekatha")}</th>
                        <th style={thStyleCompact}>{t("PlanetAspectsCol3")}</th>
                        <th style={thStyleCompact}>{t("PlanetAspectsCol4")}</th>
                        <th style={thStyleCompact}>{t("PlanetAspectsCol5")}</th>
                        <th style={thStyleCompact}>{t("PlanetAspectsCol6")}</th>
                        <th style={thStyleCompact}>{t("PlanetAspectsCol7")}</th>
                    </tr>
                </thead>
                <tbody>
                    {planetData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                            <td style={tdStyleCompact}>{row.planet}</td>
                            <td style={tdStyleCompact}>{row.nekathaAdhipathi}</td>
                            <td style={tdStyleCompact}>{row.upaGraha}</td>
                            <td style={tdStyleCompact}>{row.nakAdipathiThenpathBhavaya}</td>
                            <td style={tdStyleCompact}>{row.thenpathBhavaya}</td>
                            <td style={tdStyleCompact}>{row.nakAdipathiAithiBhavaya}</td>
                            <td style={tdStyleCompact}>{row.aithiBhavaya}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

PlanetAspectsTable.propTypes = {
    planetData: PropTypes.array.isRequired,
};
